export default class FlashcardMetadata {
  constructor(metadata, flashcard) {
    this.difficulty = metadata.p;
    this.flashcard = flashcard;
    this.totalAnswers = metadata.numAnswered;
    this.totalCorrect = metadata.numAnsweredCorrectly;

    this.answers = this.calculatedAnswerStats(metadata.answerStats);
  }

  calculatedAnswerStats(answerStats) {
    const roundPercentages = this.flashcard.type === 'Multiple Choice' && this.flashcard.answers.filter(a => a.correct).length === 1;

    const flashcardAnswerIds = this.flashcard.answers.map(a => a.id);
    const filteredAnswerStats = answerStats.filter(answerStat => flashcardAnswerIds.includes(answerStat.answerId));
    const answerStatsCount = filteredAnswerStats.reduce((acc, curr) => acc += curr.count, 0);

    let totalPercentage = 0;
    const answers = this.flashcard.answers.map((answer, index) => {
      let answerStat = answerStats.find(as => as.answerId === answer.id);
      if (!answerStat) {
        answerStat = {
          answerId: answer.id,
          count: 0,
        };
      }
      let answerPercentage = Math.round((answerStat.count / answerStatsCount) * 100);
      totalPercentage += answerPercentage;

      // If we are on the last answer and the percentage isn't 100%, we can fudge the last % a bit to make it an even 100%
      if (roundPercentages && (index === this.flashcard.answers.length - 1) && (totalPercentage !== 100)) {
        const difference = 100 - totalPercentage;
        answerPercentage += difference;
      }

      answerStat.percentage = answerPercentage;
      return answerStat;
    });

    return answers;
  }

  get correctPercent() {
    return Math.round(100 * (this.totalCorrect / this.totalAnswers));
  }

  get isValid() {
    return this.totalAnswers > 0;
  }

  get difficultyLabel() {
    if (!this.difficulty || typeof this.difficulty !== 'number') return null;
    if (this.difficulty >= 0.8) return 'Easy';
    if (this.difficulty >= 0.7) return 'Medium';
    if (this.difficulty >= 0.5) return 'Hard';
    return 'Challenge';
  }
}
